import axios from 'axios';

/**
 * Separate axios instance for Trade Partner endpoints. We can't reuse the
 * admin `api` client because:
 *   1. It attaches `gl_admin_token` and bounces on 401 — would log admin
 *      out unnecessarily when a partner endpoint rejects them.
 *   2. Partner JWTs live in their own namespace (`gl_partner_token`).
 *   3. Failed partner auth must redirect to `/partners` (not `/admin/login`).
 */
const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const partnerApi = axios.create({ baseURL: API_BASE });

partnerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('gl_partner_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

partnerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      try { localStorage.removeItem('gl_partner_token'); } catch (e) { /* noop */ }
      try { localStorage.removeItem('gl_partner_user'); } catch (e) { /* noop */ }
      // Don't auto-redirect — the gate component handles UI state. Loud
      // redirects mid-form-submit are a worse UX than letting the caller
      // surface "session expired" inline.
    }
    return Promise.reject(error);
  },
);

export function getPartnerToken() {
  try { return localStorage.getItem('gl_partner_token'); } catch (e) { return null; }
}

export function getPartnerUser() {
  try {
    const raw = localStorage.getItem('gl_partner_user');
    return raw ? JSON.parse(raw) : null;
  } catch (e) { return null; }
}

export function setPartnerSession({ token, partner }) {
  localStorage.setItem('gl_partner_token', token);
  localStorage.setItem('gl_partner_user', JSON.stringify(partner));
}

export function clearPartnerSession() {
  localStorage.removeItem('gl_partner_token');
  localStorage.removeItem('gl_partner_user');
}

export default partnerApi;
